(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ugc-video"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Глобальний завантажувач Swiper (одноразово, без race conditions)
  function loadSwiperOnce () {
    if (window._ksSwiperLoader) return window._ksSwiperLoader

    window._ksSwiperLoader = new Promise((resolve, reject) => {
      const onReady = () => {
        if (window.Swiper) { resolve(); return }
      }

      // CSS
      if (!document.querySelector('#swiper-stylesheet')) {
        const stylesheet = document.createElement('link')
        stylesheet.href = 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css'
        stylesheet.rel = 'stylesheet'
        stylesheet.id = 'swiper-stylesheet'
        stylesheet.integrity = 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow='
        stylesheet.crossOrigin = 'anonymous'
        document.head.appendChild(stylesheet)
      }

      // JS
      if (!document.querySelector('#swiper-script')) {
        const script = document.createElement('script')
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js'
        script.id = 'swiper-script'
        script.integrity = 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0='
        script.crossOrigin = 'anonymous'
        script.onload = onReady
        script.onerror = () => reject(new Error('Failed to load Swiper'))
        document.head.appendChild(script)
      } else {
        // Якщо скрипт уже є — чекаємо поки зʼявиться window.Swiper
        if (window.Swiper) { resolve(); return }
        const maxWait = 2000
        const started = Date.now()
        const tick = () => {
          if (window.Swiper) { resolve(); return }
          if (Date.now() - started > maxWait) {
            reject(new Error('Swiper not available'))
            return
          }
          requestAnimationFrame(tick)
        }
        tick()
      }
    })

    return window._ksSwiperLoader
  }

  class KsShoppableVideos extends HTMLElement {
    constructor () {
      super()
      this._destroyed = false
      this._swiper = null
    }

    connectedCallback () {
      loadSwiperOnce()
        .then(() => {
          if (this._destroyed) return
          this.initSlider()
          this.bindVideoControls()
          this.setupAutoplayObserver()
        })
        .catch(() => {
          const root = this.querySelector('.swiper')
          if (root) root.classList.add('ks-fallback-visible')
        })
    }

    disconnectedCallback () {
      this._destroyed = true
      if (this._swiper && this._swiper.destroy) {
        this._swiper.destroy(true, true)
        this._swiper = null
      }
    }

    initSlider () {
      const root = this.querySelector('.swiper')
      if (!root) return

      const options = this.buildOptions({
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
        paginationEl: this.querySelector('.swiper-pagination'),
        scrollbarEl: this.querySelector('.swiper-scrollbar'),
      })

      try {
        this._swiper = new window.Swiper(root, options)

        this._swiper.on('slideChange', () => {
          root.classList.add('swiper-is-changing')
          this.onSlideChange()
        })
        this._swiper.on('slideChangeTransitionEnd', () => {
          root.classList.remove('swiper-is-changing')
        })
      } catch (e) {
        root.classList.add('ks-fallback-visible')
      }
    }

    buildOptions (els) {
      const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1
      return {
        rewind: true,
        speed: Number(this.dataset.sliderSpeed),
        breakpoints: {
          0:    { slidesPerView: Number(this.dataset.breakpointXs)  * partialSlidesMobile },
          576:  { slidesPerView: Number(this.dataset.breakpointSm)  },
          768:  { slidesPerView: Number(this.dataset.breakpointMd)  },
          992:  { slidesPerView: Number(this.dataset.breakpointLg)  },
          1200: { slidesPerView: Number(this.dataset.breakpointXl)  },
          1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
        },
        navigation: {
          enabled: this.dataset.sliderNav === 'true',
          nextEl: els.nextEl,
          prevEl: els.prevEl
        },
        pagination: {
          enabled: this.dataset.sliderPagination === 'true',
          type: this.dataset.sliderPaginationType,
          el: els.paginationEl,
          dynamicBullets: true,
          dynamicMainBullets: 2,
          renderFraction: (currentClass, totalClass) =>
            `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        },
        scrollbar: {
          enabled: this.dataset.sliderScrollbar === 'true',
          el: els.scrollbarEl,
          draggable: true
        },
        autoplay: this.dataset.sliderAutoplay !== '0'
          ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
          : undefined,
        watchSlidesProgress: true,
        mousewheel: { enabled: true, forceToAxis: true },
      }
    }

    bindVideoControls () {
      this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
        btn.addEventListener('click', () => {
          const video = btn.closest('.ks-shoppable-videos-video-wrapper')?.querySelector('video')
          if (video) this.onVideoPlay(video)
        })
      })

      this.querySelectorAll('video').forEach(video => {
        video.addEventListener('click', () => this.onVideoPlay(video))
      })
    }

    setupAutoplayObserver () {
      const lazyVideosObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) entry.target.play() })
      }, { rootMargin: '0px 0px 300px 0px' })

      this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
        lazyVideosObserver.observe(el)
      })
    }

    onSlideChange () {
      this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      })
    }

    onVideoPlay (video) {
      const card = video.closest('.ks-shoppable-videos-card')
      if (!card) return

      this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
        if (elem.dataset.index !== card.dataset.index) {
          elem.setAttribute('data-is-playing', 'false')
          elem.querySelector('video')?.pause()
        }
      })

      const isPlaying = card.dataset.isPlaying === 'true'
      card.setAttribute('data-is-playing', isPlaying ? 'false' : 'true')
      if (isPlaying) {
        video.pause()
      } else {
        video.muted = true
        video.play()
      }
    }
  }

  customElements.define('ks-shoppable-videos', KsShoppableVideos)
})();

  } catch(e) { console.error(e); }
})();
})();
